export const cl = {
  inp: {
    width: '95%',
    height: '40px',
    padding: '8px 14px 8px 14px',
    background: '#ffffff',
    borderRadius: '6px',
    border: 'none',
    outline: 'none',
    fontSize: ' 14px',
    letterSpacing: '0.04em',
    transition: 'all 0.2s ease-in-out',
    margin: '15px 0'
  },
  btn: {
    padding: '0px 36px',
    color: '#ffffff',
    background: '#df3f3f',
    minWidth: '148px',
    height: '40px',
    fontWeight: 'bold',
    fontSize: '16px',
    letterSpacing: '0.04em',
    borderRadius: '6px',
    cursor: 'pointer',
    border: 'none',
    outline: 'none',
    transition: 'all 0.4s ease-in-out'
  },
  wr: {
    margin: '28px 0 28px 0',
    padding: 28,
    boxShadow: "0px 2px 10px rgb(0 0 0 / 14%)",
    background: '#f8ecc7',
    borderRadius: 10,
    maxWidth: '100%'
  },
  label: {
    fontSize: '16px',
    fontWeight: 600,
    color: "#563916",
    letterSpacing: '0.2em',
  },
  inpFocus: {
    boxShadow: '0px 2px 10px rgb(0 0 0 / 12%)'
  },
  btnHover: {
    boxShadow: '0px 0px 10px rgb(205 17 17 / 50%)'
  }
}